import type { AiAppCenterModule } from '../types'

export const activityModule: AiAppCenterModule = {
  key: 'activity',
  label: '活动报名',
  desc: '活动发布 / 在线报名 / 签到管理',
  path: '/activity',
  homePath: '/activity/overview',
  icon: 'ep:calendar',
  color: '#f59e0b'
}
